import {Injectable} from '@angular/core';

@Injectable()
export class SessionStorageService {

    private keyBlogArticleFilterSessionStorage = 'blogArticleFilters';
    private menuSessionStorage = 'menu';
    private dateMenuSessionStorage = 'dateMenu';

    constructor() {}

    setBlogArticleFilters(data) {
        sessionStorage.setItem(this.keyBlogArticleFilterSessionStorage, JSON.stringify(data));
    }

    getBlogArticleFilters() {
        return JSON.parse(sessionStorage.getItem(this.keyBlogArticleFilterSessionStorage));
    }

    removeBlogArticleFilters() {
        sessionStorage.removeItem(this.keyBlogArticleFilterSessionStorage);
    }

    setDateMenu(date: Date) {
      sessionStorage.setItem(this.dateMenuSessionStorage, JSON.stringify(new Date()));
    }

    getDateMenu(): Date {
      return JSON.parse(sessionStorage.getItem(this.dateMenuSessionStorage));
    }

    removeDateMenu() {
      sessionStorage.removeItem(this.dateMenuSessionStorage);
    }

    setMenu(data) {
      sessionStorage.setItem(this.menuSessionStorage, JSON.stringify(data));
    }

    getMenu() {
      return JSON.parse(sessionStorage.getItem(this.menuSessionStorage));
    }

  removeMenu() {
    sessionStorage.removeItem(this.menuSessionStorage);
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/sessionStorage.service.ts